import { motion } from "framer-motion";
import { ShieldCheck, Lightning, Eye, FileText, ClockCounterClockwise, Headset } from "@phosphor-icons/react";

const items = [
  { icon: ShieldCheck, title: "No Collateral Required", desc: "Access funds based on your receivables — not on hard assets you'd rather grow with." },
  { icon: Lightning, title: "Fast Digital Process", desc: "From onboarding to funding, everything happens online with minimal friction." },
  { icon: Eye, title: "Transparent Pricing", desc: "Simple, upfront pricing — no hidden charges or fine-print surprises." },
  { icon: FileText, title: "Simple Documentation", desc: "A short list of essentials, no mountain of paperwork or repeat submissions." },
  { icon: ClockCounterClockwise, title: "Quick Approvals", desc: "Target turnaround of 24–48 hours for verified invoices during early access." },
  { icon: Headset, title: "Dedicated Support", desc: "A real relationship manager for each business — not a ticketing queue." },
];

export default function Benefits() {
  return (
    <section id="benefits" data-testid="benefits-section" className="py-24 md:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-emerald-700 mb-3">Benefits</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
            Working capital, built for how businesses actually run.
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`benefit-card-${i}`}
              className="rounded-2xl bg-white border border-slate-100 p-8 shadow-soft hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div className="grid place-items-center w-11 h-11 rounded-xl bg-emerald-50 text-emerald-700">
                <it.icon size={22} weight="duotone" />
              </div>
              <h3 className="mt-5 font-display text-lg md:text-xl font-medium text-slate-900">{it.title}</h3>
              <p className="mt-2 text-slate-500 leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
